// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-3f6ac075]{display:none}.sf-divider[data-v-3f6ac075]{--divider-border-color:#dadada}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
